const TRANSLATIONS = {
    en: {
        alertBody: ' It is not possible to make edits to this board, as it is already on the blockchain, making it immutable. You can, however, make a copy of this board and edit the copy.',
        alertTitle: 'You are currently viewing a minted board.',
        body: "This broke for whatever reason. A little message popped up explaining why.",
        title: 'Unable to Load Board',
        
    }
}

export default TRANSLATIONS